const formatFacilityOptions = (options) => {
  var results = [];
  options.map((option) => {
    results.push({
      value: option.id,
      label: option.name,
    });
  });
  return results;
};

const formatClientOptions = (options) => {
  return options.map((option) => formatClientOption(option));
};

const formatMedOptions = (options) => {
  return options.map((option) => formatMedOption(option));
};

const formatClientOption = (option) => {
  return {
    value: option.id,
    label: `${option.first_name} ${option.last_name}`,
  };
};

const formatMedOption = (option) => {
  return {
    value: option.name,
    label: option.name,
  };
};

export {
  formatFacilityOptions,
  formatClientOptions,
  formatMedOptions,
  formatMedOption,
  formatClientOption,
};
